import React from 'react';
import { LinkRequestType } from '~/types/models/testimonial';
import ProfileLink from './ProfileLink';
import { Links } from './SearchModal';

export interface ProfileLinksProps {
  className?: string;
  onChange: (profileKey: string, value: Links) => void;
  links?: Links;
}

export default function ProfileLinks({
  className,
  onChange,
  links,
}: ProfileLinksProps) {
  const linkRows = [
    {
      key: 'facebook',
      placeholder: 'Facebook link',
      linkType: LinkRequestType.Facebook,
    },
    {
      key: 'linkedin',
      placeholder: 'Linkedin Profile',
      linkType: LinkRequestType.LinkedIn,
    },
    {
      key: 'twitter',
      placeholder: 'Twitter link',
      linkType: LinkRequestType.Twitter,
    },
    {
      key: 'other',
      placeholder: 'Other link',
      linkType: LinkRequestType.Website,
    },
  ];
  return (
    <div className={className}>
      <div className='mb-[15px] text-base font-bold'>Social and web links</div>
      {linkRows.map((link, index) => (
        <ProfileLink
          links={links}
          linkKey={link.key}
          onChange={onChange}
          key={index}
          placeholder={link.placeholder}
          linkType={link.linkType}
        />
      ))}
    </div>
  );
}
